import { useMemo, useState } from "react";
import { hotTopics, type HotTopic } from "@/mocks/fanCommunity";
import { badgeClasses, type BadgeTone } from "./tone";

const filters = ["全部", ...Array.from(new Set(hotTopics.map((t) => t.tag)))];

export default function HotSection() {
  const [active, setActive] = useState("全部");

  const list: HotTopic[] = useMemo(
    () => (active === "全部" ? hotTopics : hotTopics.filter((t) => t.tag === active)),
    [active]
  );

  return (
    <section id="hot" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-chat-heart-line" />
              超话热榜 · 社区动态
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              捷克动态，一站追更
            </h2>
            <p className="mt-3 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              汇聚捷克最新舞台、企划与活动消息。超话热榜持续更新，帮你不错过任何一个应援节点。
            </p>
          </div>
          <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
            共 {hotTopics.length} 条动态 · 每日更新
          </p>
        </div>

        {/* filter tabs */}
        <div className="mt-8 flex flex-wrap gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        {/* list */}
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-100 transition-colors hover:border-primary-200"
            >
              <div className="relative h-48 md:h-52 w-full overflow-hidden">
                <img
                  src={t.image}
                  alt={t.title}
                  title={`${t.title} - 吃瓜捷克超话热点`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${badgeClasses[t.tagTone]}`}
                >
                  {t.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {t.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{t.summary}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {t.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {t.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}